import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import {
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import SectionCard from "./SectionCard";
import CurrencySelect from "./CurrencySelect";
import { useCurrencies } from "./useCurrencies";

const SubAgentProvision: React.FC = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<any>();
  const { currencies, loading, getDefaultId } = useCurrencies();
  const rows = values.provisionForms ?? [];

  useEffect(() => {
    if (!currencies) return;
    if (!Array.isArray(values.provisionForms) || values.provisionForms.length === 0) {
      setFieldValue("provisionForms", [
        {
          provisionPercentage: 0,
          neto: 0,
          minimumProvision: 0,
          maximumProvision: 0,
          fixedProvision: 0,
          minPrice: 0,
          currencyId: getDefaultId(),
        },
      ]);
    } else {
      const patched = values.provisionForms.map((r: any) => ({
        ...r,
        currencyId: r?.currencyId ?? getDefaultId(),
      }));
      setFieldValue("provisionForms", patched);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencies]);

  const addRow = () =>
    setFieldValue("provisionForms", [
      ...(values.provisionForms ?? []),
      {
        provisionPercentage: 0,
        neto: 0,
        minimumProvision: 0,
        maximumProvision: 0,
        fixedProvision: 0,
        minPrice: 0,
        currencyId: getDefaultId(),
      },
    ]);

  const removeRow = (idx: number) =>
    setFieldValue(
      "provisionForms",
      (values.provisionForms ?? []).filter((_: any, i: number) => i !== idx)
    );

  return (
    <SectionCard title="Provision">
      <RadioGroup
        row
        name="provisionFormType"
        value={values.provisionFormType || "PERCENTAGE"}
        onChange={handleChange}
      >
        <FormControlLabel value="PERCENTAGE" control={<Radio />} label="Percentage" />
        <FormControlLabel value="FIXED" control={<Radio />} label="Fixed" />
        <FormControlLabel value="MIXED" control={<Radio />} label="Mixed" />
      </RadioGroup>

      {(rows.length ? rows : [{}]).map((_: any, idx: number) => (
        <Grid container spacing={2} key={idx} alignItems="center" style={{ marginBottom: 8 }}>
          <Grid item xs={12} md={2}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].provisionPercentage`}
              label="% Provision"
              value={rows[idx]?.provisionPercentage ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].neto`}
              label="Neto"
              value={rows[idx]?.neto ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].minimumProvision`}
              label="Min"
              value={rows[idx]?.minimumProvision ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].maximumProvision`}
              label="Max"
              value={rows[idx]?.maximumProvision ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].fixedProvision`}
              label="Fixed"
              value={rows[idx]?.fixedProvision ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <TextField
              type="number"
              fullWidth
              name={`provisionForms[${idx}].minPrice`}
              label="Min Price"
              value={rows[idx]?.minPrice ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <CurrencySelect
              name={`provisionForms[${idx}].currencyId`}
              label="Curr"
              value={rows[idx]?.currencyId}
              onChange={handleChange}
              currencies={currencies}
              loading={loading}
            />
          </Grid>

       
        </Grid>
      ))}

    </SectionCard>
  );
};

export default SubAgentProvision;
